import * as yup from "yup";

export const createJobSchema = yup.object().shape({
  jobName: yup
    .string()
    .trim()
    .required("This field is mandatory.")
    .min(2, "Must be at least 2 characters")
    .max(255, "Cannot exceed 255 characters"),
  jobDesc: yup
    .string()
    .trim()
    .test("not-empty", "Job Description is required", function (value) {
      if (!value) return false;
      // Check if it's just empty HTML from ReactQuill
      if (value === "<p><br></p>" || value === "<p></p>") return false;
      // Remove all HTML tags and check if there's actual content
      const textContent = value.replace(/<[^>]*>/g, "").trim();
      return textContent.length > 0;
    })
    .max(5000, "Cannot exceed 5000 characters"),
  jobReq: yup.string().trim().max(5000, "Cannot exceed 5000 characters"),
  minSalary: yup.number().typeError("Enter Number"),
  maxSalary: yup.number().typeError("Enter Number"),
  currencyId: yup.mixed<string | number>(),
  currencyName: yup.string().trim().max(50, "Cannot exceed 50 characters"),
  countryId: yup.string().trim().max(255, "Cannot exceed 255 characters"),
  countryName: yup
    .string()
    .trim()
    .max(255, "Country Name cannot exceed 255 characters"),
  workStateId: yup.string().trim(),
  workState: yup
    .string()
    .trim()
    .max(255, "Cannot exceed 255 characters")
    .required("Required"),
  province: yup.string().trim().max(255, "Cannot exceed 255 characters"),
  city: yup.string().trim().max(255, "Cannot exceed 255 characters"),
  stateId: yup.string().trim(),
  cityId: yup.string().trim(),
  maxExp: yup
    .number()
    .required("Required")
    .typeError("Enter Number")
    .min(0, "Cannot be negative"),
  minExp: yup
    .number()
    .required("Required")
    .typeError("Enter Number")
    .min(0, "Cannot be negative"),
  jobLevel: yup
    .string()
    .trim()
    .required("Required")
    .max(255, "Cannot exceed 255 characters"),
  jobLevelId: yup.mixed<string | number>(),
  jobType: yup
    .string()
    .trim()
    .required("Job Type is required")
    .max(255, "Cannot exceed 255 characters"),
  industryId: yup.mixed<string | number>(),
  industryName: yup.string().trim().max(255, "Cannot exceed 255 characters"),
  workTypeId: yup.mixed<string | number>(),
  workplaceTypeId: yup.mixed<string | number>(),
  workType: yup
    .string()
    .trim()
    .required("Work Type is required")
    .max(255, "Work Type cannot exceed 255 characters"),
  vacancy: yup
    .number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === "" ||
        originalValue === null ||
        originalValue === undefined
        ? null
        : value;
    })
    .typeError("Must be number"),
  qualTypeId: yup.mixed<string | number>(),
  qualTypeName: yup.string().trim().max(255, "Cannot exceed 255 characters"),
  skills: yup
    .array()
    .of(
      yup
        .object()
        .shape({
          skillId: yup.string().trim(),
          skillName: yup.string().trim().required("Skill Name is required"),
        })
        .required()
    )
    .min(1, "At least one skill is required"),
});

export type CreateJobSchemaType = yup.InferType<typeof createJobSchema>;
